//import UIkit from "uikit";
//import Icons from "uikit/dist/js/uikit-icons";
//import Swup from "swup";
//import $ from 'jquery';
//import swupRenderPage from "./swupRenderPage.js";

import gsap from 'gsap';
import ScrollTrigger from "gsap/ScrollTrigger";
//import SplitText from "gsap/SplitText";
gsap.registerPlugin(
  ScrollTrigger,
  //SplitText
); 

import barba from '@barba/core';
import 'bootstrap';

import "../components/popup-searchform/jquery.autocomplete.min.js";

import '../components/field-date/field-date.js';
import '../components/same-height/same-height.js';
import '../components/main-menu/main-menu.js';
import '../components/image-compare/image-compare.js';
import '../components/video/video.js';
import '../components/form/form.js';
import '../components/map/map.js';
import '../components/scrollspy/scrollspy.js';
import '../components/menu-opener/menu-opener.js';

import "../components/popup-searchform/popup-searchform.js";
import "../components/banner-browser-upgrade/banner-browser-upgrade.js";
import "../components/banner-cookies/banner-cookies.js";

import "../components/slideshow/slideshow.js";
import "../components/footer/footer.js";

import "../components/card-team-member/card-team-member.js";

if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual';
}
//import '../components/uk-accordion/accordion.js';
console.log('ABC');
barba.init({
  transitions: [{
    name: 'default-transition',
    leave(data) {
      var tl = gsap.timeline();
      tl.to('.px-drapes .outer,.px-drapes .inner', { width:'100vw', duration:.2 }, '>')
      tl.to('.px-drapes .outer', { transform:'translateX(-100vw)', duration:.2 },'>')
      tl.to(data.current.container, { opacity:'0', duration:.1 },'>')
      //tl.to(data.next.container, { opacity:'1', duration:.1 },'>')
      return tl;
    },
    enter(data) {
      console.log('enter');
      //removeDrapes();
      /*var tl = gsap.timeline();
      //tl.to(data.current.container, { opacity:'0', duration:.1 },'>')
      tl.to(data.next.container, { opacity:'1', duration:.1 },'>')
      tl.to('.px-drapes .outer', { transform:'translateX(0)', duration:.2 },'>')
      tl.to('.px-drapes .outer,.px-drapes .inner', { width:'0', duration:.2 }, '>')
      return tl;*/
      return gsap.from(data.next.container, {
        opacity: 0
      });
    }
  }],
  views: [{
    namespace: 'home',
    beforeEnter() {
      // update the menu based on user navigation
      //menu.update();
      console.info('beforeenter')
    },
    afterEnter() {
      // refresh the parallax based on new page content
      //parallax.refresh();
      console.info('afterenter');
      jQuery(window).scrollTop(0);
      var event;
      if (typeof Event === "function") {
        event = new Event("px-ready");
      } else {
        event = document.createEvent("Event");
        event.initEvent("px-ready", true, true);
      }
      window.dispatchEvent(new Event("px-ready"));
    }
  }]
  //window.dispatchEvent(new Event("px-ready"));
})

jQuery(function () {
  //window.dispatchEvent(new Event('px-ready'));
  //UIkit.offcanvas.hide()
  window.setTimeout(function () {
    jQuery("html").removeClass("is-animating");
    jQuery("html").attr("style", "");
  }, 30);
  var event;
  if (typeof Event === "function") {
    event = new Event("px-ready");
  } else {
    event = document.createEvent("Event");
    event.initEvent("px-ready", true, true);
  }

  window.dispatchEvent(event);
});

//console.log('Webpack loaded!');

/*UIkit.util.on('#s4video','show', function(){
    console.log('showvideo');
    jQuery(window).trigger('resize')
})*/

window.addEventListener("px-ready", function () {
  console.log('triggered ready');
  //remove blinds
  animations();

  jQuery('body').removeClass('menu-is-open');
  window.setTimeout(function () {
    jQuery(window).trigger('resize');
  }, 30);
  jQuery(document).on("click", 'a[href^="#"]', function (event) {
    //console.log('x');
    console.log("scroller");
    if (!jQuery(this).hasClass("uk-accordion-title")) {
      event.preventDefault();

      var scrolltop = 0;
      if (
        jQuery(this).attr("href") != "#" &&
        jQuery(this).attr("data-noscrollup") != "1" &&
        jQuery(jQuery(this).attr("href")).length
      ) {
        scrolltop = jQuery(jQuery(this).attr("href")).offset().top;
      }

      jQuery("html, body").animate(
        {
          scrollTop: scrolltop,
        },
        350
      );
    }
  });
});

function animations(){
  var tl = gsap.timeline();
  //tl.to(data.current.container, { opacity:'0', duration:.1 },'>')
  //tl.to(data.next.container, { opacity:'1', duration:.1 },'>')
  tl.set('.px-main-menu', { opacity:'0', transform:'translateY(-100px)' })
  tl.to('.px-drapes .outer', { transform:'translateX(0)', duration:.2 },'>')
  tl.to('.px-drapes .outer,.px-drapes .inner', { width:'0', duration:.2 }, '>')
  tl.to('.px-main-menu', { opacity:'1',transform:'translateY(0)', duration:.5 }, '>')

  //Home Section 2
  var tl_home_s2 = gsap.timeline({
    //paused:true,
    scrollTrigger:{
      trigger: ".px-home-s2-s3",
      start: "top center",
      end: "bottom center",
      //pin:'.px-home-s2-s3 .bg',
      onUpdate: self => {
        //console.log("progress:", self.progress.toFixed(3));
        jQuery('.px-home-s2-s3 .bg').css('top',self.progress.toFixed(3)*100 + '%');
        jQuery('.px-home-s2-s3 .bg').css('transform','translate(0, -'+self.progress.toFixed(3)*100 + '%)');
      },
    },
    //scrub: 1
  });
  /*tl_home_s2.addLabel('start')
    .from('.px-home-s2-s3 .bg', {top:"0%",transform:'translate(0, 0)'})
    .to('.px-home-s2-s3 .bg', {top:"100%",transform:'translate(0, -100%)'})
    .addLabel('end')*/
}